import { inputBatchApi } from "../features/inputBatches/inputBatchApi";
import { batchApi } from "../features/batches/batchApi";
import { itemApi } from "../features/items/itemApi";
import { itemRoutingApi } from "../features/itemRoutings/itemRoutingApi";
import { lineApi } from "../features/lines/lineApi";
import { machineCapabilityApi } from "../features/machineCapabilities/machineCapabilityApi";
import { machineApi } from "../features/machines/machineApi";
import { oemApi } from "../features/oems/oemApi";
import { operationApi } from "../features/operations/operationApi";
import { pageApi } from "../features/pages/pageApi";
import { plantApi } from "../features/plants/plantApi";
import { processApi } from "../features/processes/processApi";
import { qrApi } from "../features/qr/qrApi";
import { rawMaterialApi } from "../features/rawMaterials/rawMaterialApi";
import { roleApi } from "../features/roles/roleApi";
import { relationTypeApi } from "../features/relationTypes/relationTypeApi";
import { settingsApi } from "../features/settings/settingsApi";
import { shiftApi } from "../features/shifts/shiftApi";

const dataApis = [
  inputBatchApi,
  batchApi,
  itemApi,
  itemRoutingApi,
  lineApi,
  machineCapabilityApi,
  machineApi,
  oemApi,
  operationApi,
  pageApi,
  plantApi,
  processApi,
  qrApi,
  rawMaterialApi,
  roleApi,
  relationTypeApi,
  settingsApi,
  shiftApi,
];

export const resetDataApiCache = (dispatch) => {
  dataApis.forEach((api) => {
    dispatch(api.util.resetApiState());
  });
};
